'use strict';

// Pull in the styles ...
import './main/scss/main.scss';

import React from 'react';
import {HashRouter, Navigate, Route, Routes} from 'react-router-dom';

// lib-react
import App from '@uw-it-sis/lib-react/lib/App';
import {AppContext} from '@uw-it-sis/lib-react/lib/AppContext';
import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import history from '@uw-it-sis/lib-react/lib/History';
import {render} from '@uw-it-sis/lib-react/lib/Render';

import Header from '@uw-it-sis/lib-react-myplan/lib/Header';
import Footer from '@uw-it-sis/lib-react-myplan/lib/Footer';
import AppNavigation from '@uw-it-sis/lib-react-myplan/lib/AppNavigation';

// Page Components.
import ViewIdentifier from "./main/js/common/ViewIdentifier";
import PrintView from "./main/js/print/PrintView";
import ImportSocialPlan from "./main/js/importSocial/ImportSocialPlan";
import ScheduleBuilder from "./main/js/scheduleBuilder/ScheduleBuilder";
import OptionalCharges from "./main/js/prereg/OptionalCharges";
import PreRegWorkflow from "./main/js/prereg/PreRegWorkflow";

import RegTools from "./main/js/common/RegTools";

/**
 * Define the routes.
 */
const routes =
    <Routes>
        <Route path="import" element={<ImportSocialPlan />}>
            <Route path=":state" element={<ImportSocialPlan />} />
            <Route path="" element={<ImportSocialPlan />} />
        </Route>
        <Route path="print" element={<PrintView />} />
        <Route path="schedule" element={<ScheduleBuilder />}>
            <Route path=":term" element={<ScheduleBuilder />} />
            <Route path="" element={<ScheduleBuilder />} />
        </Route>
        <Route path=":identifier/prereg" element={<PreRegWorkflow />} />
        <Route path=":identifier/optcharges" element={<OptionalCharges />} />
        <Route path=":identifier" element={<ViewIdentifier />}>
            <Route path=":anchor" element={<ViewIdentifier />} />
            <Route path="" element={<ViewIdentifier />} />
        </Route>
        <Route path="" element={<ViewIdentifier />} />
    </Routes>;

let devTools = []
if (process.env.NODE_ENV === 'development') {
    devTools.push({key: "regtools", component: <RegTools/>});
}

/**
 * Put the AppStore in the React context so that it's available to any class that needs it.
 * Provide appStore and browser history in the context.
 */
const router = (
    <AppContext.Provider value={
        {
            appStore: appStore,
            history: history
        }
    }>
        <HashRouter>
            <App name={"plan"} routes={routes}
                 title="MyPlan"
                 header={<Header />}
                 footer={<Footer devTools={devTools}/>}
                 navigation={<AppNavigation />} />
        </HashRouter>
    </AppContext.Provider>
);

render(router);
